import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import React, { ReactElement } from 'react'
import { DifficultLevel } from '../../api/DomainTypes'
import ChatHint from './ChatHint'
import HoverImage from './HoverImage'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(5),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        padding: theme.spacing(1)
      }
    },
    levelsBlock: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(2),
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      alignItems: 'center',
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'flex-start'
        // flexDirection: 'column',
      }
    },
    levelCard: {
      minWidth: '256px',
      [theme.breakpoints.down('sm')]: {
        minWidth: 'auto',
        // maxWidth: '50%',
        flexBasis: '33%'
      },
      [theme.breakpoints.down('xs')]: {
        minWidth: 'auto',
        // maxWidth: '50%',
        flexBasis: '100%'
      }
    }
  })
)

type Props = {
  difficultLevels: Array<DifficultLevel>
  onChoose?: (item: DifficultLevel) => void
}

export default function ChooserDifficultLevel({
  difficultLevels,
  onChoose
}: Props): ReactElement {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.levelsBlock}>
        {difficultLevels?.map(item => {
          return (
            <div
              className={classes.levelCard}
              style={{ minHeight: '389.2px' }}
              key={item.id}
              onClick={() => onChoose && onChoose(item)}
            >
              <HoverImage width={140} height='389.2px' item={item} />
            </div>
          )
        })}
      </div>
      {/* <ChatHint title="Выберите уровень сложности" arrowSide="up" /> */}
    </div>
  )
}
